<template>
    <div>
        <!-- 스케줄예약, 스케줄수정 -->
        <div v-show="isShow" class="view-area">
            <table class="com-table left">
                <colgroup>
                    <col style="width: 160px" />
                    <col style="width: 560px" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>
                            이용권 종류
                            <span class="imp">*</span>
                        </th>
                        <td colspan="2">
                            <div class="info flex">
                                <div class="com-radio">
                                    <input
                                        id="resereTypeP"
                                        name="reserveType"
                                        v-model="reserveType"
                                        :disabled="isFixedContract || isModify"
                                        @change="onUpdateReserveType($event)"
                                        type="radio"
                                        value="P"
                                    />
                                    <label for="resereTypeP">개인</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        id="resereTypeD"
                                        name="reserveType"
                                        v-model="reserveType"
                                        :disabled="isFixedContract || isModify"
                                        @change="onUpdateReserveType($event)"
                                        type="radio"
                                        value="D"
                                    />
                                    <label for="resereTypeD">듀엣</label>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            강사명
                            <span class="imp">*</span>
                        </th>
                        <td>
                            <select-form
                                :disabled="isDisableSelectTeacher || isAttend"
                                :select-data="[...selectFormTeacher.data]"
                                :select-value="[...selectFormTeacher.value]"
                                :selected-value="selectedTeacher"
                                class="w200"
                                @update:set="updateEditFieldReservSelectedTeacher"
                            ></select-form>
                        </td>
                    </tr>

                    <tr>
                        <th>
                            회원 선택
                            <span class="imp">*</span>
                        </th>
                        <td colspan="2">
                            <select-form-search
                                :disabled="
                                    step < EDIT_STEP.CUSTOMER ||
                                    isModify ||
                                    (reserveType === 'P' && selectedTicketList.length > 0) ||
                                    (reserveType === 'D' && selectedTicketList.length > 1)
                                "
                                :select-data="['선택', ...centerContractBillTicketNameList]"
                                :select-value="['', ...centerContractBillTicketValueList]"
                                :selected-value="''"
                                class="w600"
                                style="margin-bottom: 10px; white-space: pre-line"
                                @update:set="onUpdateTicketWith"
                                :key="selectFormSearchKey"
                            />
                            <div
                                v-for="(ticket, index) in selectedTicketList"
                                :key="index"
                                class=""
                                style="width: 100%"
                            >
                                <div
                                    class="input-del"
                                    :style="
                                        selectedProduct == null ||
                                        selectedProduct.centerContractId !==
                                            selectedTicketValueList[index].centerContractId
                                            ? 'background-color: #00C7E5'
                                            : 'background-color: #4DB650'
                                    "
                                    style="font-size: 13px; color: white; padding: 0px 0px 20px 15px; margin-top: 10px"
                                >
                                    <div style="display: inline-block; width: 95%; white-space: pre-line">
                                        {{ ticket }}
                                    </div>
                                    <button
                                        v-if="
                                            selectedProduct == null ||
                                            selectedProduct.centerContractId !==
                                                selectedTicketValueList[index].centerContractId
                                        "
                                        @click="deleteTicket(index)"
                                        class="del2"
                                    ></button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            수업일자
                            <span class="imp">*</span>
                        </th>
                        <td>
                            <single-calendar
                                ref="lessonDate"
                                :disabled="step < EDIT_STEP.LESSON_DATE || billStatus === 'O' || isAttend"
                                :start-date="lessonDate"
                                @update="updateLessonDate"
                            ></single-calendar>
                            <span v-if="!isEmpty(lessonTimeAlertMsg)" class="red-txt">{{ lessonTimeAlertMsg }}</span>
                            <span v-if="isAttend" class="red-txt">출석 및 정산 취소 후 변경 가능합니다.</span>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            수업시작시간
                            <span class="imp">*</span>
                        </th>
                        <td>
                            <select-form
                                :disabled="step < EDIT_STEP.LESSON_DATE || billStatus === 'O' || isAttend"
                                :select-data="selectFormStartHour.data"
                                :select-value="selectFormStartHour.value"
                                :selected-value="selectFormStartHour.selectedValue"
                                class="w100"
                                @update:set="updateReserveHour"
                            ></select-form>
                            <span class="dot">:</span>
                            <select-form
                                :disabled="step < EDIT_STEP.LESSON_DATE || billStatus === 'O' || isAttend"
                                :select-data="selectFormStartMin.data"
                                :select-value="selectFormStartMin.value"
                                :selected-value="selectFormStartMin.selectedValue"
                                class="w100"
                                @update:set="updateReserveMin"
                            ></select-form>
                            <select-form
                                :disabled="true"
                                :select-data="selectFormLessonTime.data"
                                :select-value="selectFormLessonTime.value"
                                :selected-value="selectFormLessonTime.selectedValue"
                                class="w100"
                            ></select-form>
                        </td>
                    </tr>
                    <tr>
                        <th>룸 선택</th>
                        <td class="time-table-wrap">
                            <table class="time-table w340">
                                <colgroup>
                                    <col style="width: 140px" />
                                    <col style="width: 200px" />
                                </colgroup>
                                <tbody>
                                    <tr v-for="(room, index) in rooms" :key="index">
                                        <th>
                                            <span class="gray">{{ room.useStartTime }} ~ {{ room.useEndTime }}</span>
                                        </th>
                                        <td>
                                            <select-form
                                                :disabled="step < EDIT_STEP.ROOM_MEMO || billStatus === 'O' || isAttend"
                                                :select-data="[...selectRoom(index).data]"
                                                :select-value="[...selectRoom(index).value]"
                                                :selected-value="room.centerRoomId"
                                                class="w170"
                                                @update:set="
                                                    (val) => {
                                                        updateEditFieldReservCenterRoom(val, room, index);
                                                    }
                                                "
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-if="false" class="btn-box">
                                <button class="com-btn">추가</button>
                                <button class="com-btn red">삭제</button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>수업메모</th>
                        <td>
                            <textarea v-model="memo" :disabled="step < EDIT_STEP.ROOM_MEMO" class="full"></textarea>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="isModify && !isUnableCancel" class="btn-line">
                <button class="com-btn" @click="checkAllowedClick('LE', 6, onClickBtnDeleteReservation)">
                    예약삭제
                </button>
            </div>
            <div class="bottom-btn">
                <button class="com-btn" @click="onClickBtnCancelReservation">취소</button>
                <button
                    v-if="!isModify && !isCheckOver"
                    :disabled="step < EDIT_STEP.ROOM_MEMO"
                    class="com-btn blue"
                    @click="onClickBtnRegistReservation"
                >
                    등록
                </button>
                <button
                    v-else-if="(isModify || !isCheckOver) && billStatus !== 'O'"
                    :disabled="step < EDIT_STEP.ROOM_MEMO"
                    class="com-btn blue"
                    @click="onClickBtnModifyReservation"
                >
                    수정
                </button>
            </div>
        </div>

        <!-- 회원 검색 결과 팝업 -->
        <search-customer-dlg
            :callback-cancel="onCancelSearchCustomerDlg"
            :callback-select="onSelectSearchCustomerDlg"
            :center-id="centerId"
            :is-show="memberPop"
        ></search-customer-dlg>
    </div>
</template>

<script>
import { maskCustomerPhone } from '@/assets/js/customerPhone';
import moment from 'moment';
import api from '@/assets/js/api';
import { Utils } from '@/assets/js/utils';
import SearchCustomerDlg from '@/components/SearchCustomerDlg';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';

export default {
    name: 'LessonReservationDlg',
    mixins: [MixinAllowedMenu],
    components: {
        SearchCustomerDlg,
    },
    computed: {
        EDIT_STEP() {
            return {
                TEACHER: 1,
                CUSTOMER: 2,
                TICKET: 3,
                LESSON_DATE: 4,
                LESSON_TIME: 5,
                ROOM_MEMO: 6,
            };
        },
        centerId() {
            return !Utils.isEmpty(this.initCenterId) ? this.initCenterId : parseInt(this.$store.getters['auth/cId']);
        },
        isDisableSelectTeacher() {
            return !this.isAllowed('SC', 1);
        },
        ticketType() {
            if (
                !Utils.isEmpty(this.selectedProduct) &&
                !Utils.isEmpty(this.selectedProduct.centerProduct) &&
                !Utils.isEmpty(this.selectedProduct.centerProduct.ticketType)
            ) {
                return this.selectedProduct.centerProduct.ticketType;
            }
            return '';
        },
    },
    watch: {
        initCenterId() {
            this.fetchReservationSetting();
        },
    },
    props: {
        initCenterId: {
            type: [Number, String],
            default: '',
        },
        selectFormTeacher: Object,
        callbackSuccess: Function,
        callbackCancel: Function,
    },
    data() {
        return {
            isShow: false,
            isFixedContract: false,
            staffId: '',
            step: 1,
            isModify: false,
            centerContractId: '', // 수정을 위한 필수값
            centerLessonScheduleId: '',
            centerLessonScheduleMasterId: '',
            lessonTimeAlertMsg: '',
            selectedTeacher: '',
            selectedCustomer: {
                name: '',
                id: '',
            },
            selectedProduct: null,
            lessonDate: '',
            selectFormCustomerProduct: {
                list: [],
                data: [],
                value: [],
                selectedValue: '',
            },
            selectFormStartHour: {
                data: [
                    '00',
                    '01',
                    '02',
                    '03',
                    '04',
                    '05',
                    '06',
                    '07',
                    '08',
                    '09',
                    '10',
                    '11',
                    '12',
                    '13',
                    '14',
                    '15',
                    '16',
                    '17',
                    '18',
                    '19',
                    '20',
                    '21',
                    '22',
                    '23',
                ],
                value: [
                    '00',
                    '01',
                    '02',
                    '03',
                    '04',
                    '05',
                    '06',
                    '07',
                    '08',
                    '09',
                    '10',
                    '11',
                    '12',
                    '13',
                    '14',
                    '15',
                    '16',
                    '17',
                    '18',
                    '19',
                    '20',
                    '21',
                    '22',
                    '23',
                ],
                selectedValue: '',
            },
            selectFormStartMin: {
                data: ['00', '30'],
                value: ['00', '30'],
                selectedValue: '',
            },
            selectFormLessonTime: {
                data: ['30분', '1시간', '1시간 30분', '2시간', '2시간 30분', '3시간'],
                value: [30, 60, 90, 120, 150, 180],
                selectedValue: 60,
            },
            selectFormRoom: [],
            memo: '',
            rooms: [],
            presetRooms: [],
            memberPop: false,
            reservationSetting: {},
            isUnableCancel: false,
            isCheckOver: false,
            billStatus: '-',
            exteriorPlan: [],
            hasSchedule: false,
            isAttend: false,

            reserveType: '', // 이용권(개인, 듀엣)
            centerContractBillTicketNameList: [], // 센터회원계약 이용권 결제 목록 SelectBox Name
            centerContractBillTicketValueList: [], // 센터회원계약 이용권 결제 목록 SelectBox Value
            selectedTicketList: [], // 선택된 이용권 리스트
            selectedTicketValueList: [], // 선택된 이용권 리스트
            selectFormSearchKey: 0, // 회원 선택 컴포넌트 키
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        selectRoom(index) {
            if (!Utils.isEmpty(this.selectFormRoom) && this.selectFormRoom.length > index) {
                return this.selectFormRoom[index];
            }
            return {
                data: ['선택 안함'],
                value: [''],
            };
        },
        async setPresetData(preset) {
            this.isAttend = false;
            for (const key in preset) {
                const val = preset[key];
                switch (key) {
                    case 'startHour':
                        this.selectFormStartHour.selectedValue = val;
                        break;
                    case 'startMin':
                        this.selectFormStartMin.selectedValue = val;
                        break;
                    case 'lessonTime':
                        // console.log(val ? val : 60);
                        this.selectFormLessonTime.selectedValue = val ? val : 60;
                        break;
                    case 'rooms':
                        // 룸 선택정보는 셀렉트 박스 초기화 문제로 별도 처리함.
                        this.presetRooms = val;
                        break;
                    default:
                        this[key] = val;
                        break;
                }
            }

            // 이용권 OT면 개인으로 변경
            if (this.lessonType)
                this.reserveType = this.lessonType == 'O' || this.lessonType == 'P' ? 'P' : this.lessonType;
            else
                this.reserveType =
                    !this.ticketType || this.ticketType == 'O' || this.ticketType == 'P' ? 'P' : this.ticketType;

            await this.fetchCustomerProductTicket();

            if (!Utils.isEmpty(this.selectedProduct)) {
                // 이 값이 셋팅되어있으면, 이용권명을 보여주지 않는다. (수업>수업관리>등록에서 사용)
                this.isFixedContract = true;
                this.selectFormLessonTime.selectedValue = this.selectedProduct.centerProduct.lessonTime || 60;
            } else if (!Utils.isEmpty(this.selectedCustomer.id) && !Utils.isEmpty(this.centerLessonScheduleId)) {
                const { data: contractData } = await this.getDailyScheduleCustomerContract(
                    this.selectedCustomer.id,
                    this.centerLessonScheduleId
                );

                this.isAttend =
                    contractData.attendanceStatus === 'O' ? true : contractData.attendanceStatus === 'X' ? true : false;
                let productIndex = 0;
                for (let product of this.selectFormCustomerProduct.list) {
                    if (
                        product.centerProductId === contractData.centerProductId &&
                        product.centerContractId === contractData.centerContractId
                    ) {
                        this.selectedProduct = product;
                        this.selectFormCustomerProduct.selectedValue = productIndex;
                        break;
                    }
                    productIndex++;
                }
            }

            // 이용권 데이터 조회
            await this.fetchCustomerProductTicketList();

            // if(!this.selectedTeacher) {
            //     this.selectedTeacher = this.staffId;
            // }

            if (!Utils.isEmpty(this.lessonDate) && !Utils.isEmpty(this.presetRooms) && this.presetRooms.length > 0) {
                // 센터룸예약 정보를 유지하기 위해 현재 예약된 날짜도 정보에 포함
                for (const room of this.presetRooms) {
                    room.lessonDate = this.lessonDate;
                }
            }
            await this.generateEditFieldRoomInfo();

            this.goNextEditStep();

            // 회원 선택 셀렉트박스 mount
            this.selectFormSearchKey += 1;
        },
        async init() {
            this.staffId = parseInt(this.$store.getters['auth/staffId']);

            await this.fetchReservationSetting();
            // await this.fetchCenterRooms();

            // 수업시작 시간 : 분
            const { timeUnitValue } = this.reservationSetting;
            if (timeUnitValue < 60) {
                for (let m = 0; m < 60; m += timeUnitValue) {
                    let min = m.toString().padStart(2, '0');
                    this.selectFormStartMin.data.push(min);
                    this.selectFormStartMin.value.push(min);
                }
            } else {
                this.selectFormStartMin.data.push('00');
                this.selectFormStartMin.value.push('00');
            }
        },
        async checkExteriorPlan() {
            const uri = `/admin/api/customer-app/center/${this.centerId}/customer/${this.selectedCustomer.id}/lesson/person/category/schedule`;
            const date = moment(this.lessonDate);
            const startDate = date.startOf('month').format('YYYY-MM-DD');
            const endDate = date.endOf('month').format('YYYY-MM-DD');

            if (startDate == 'Invalid date') return;
            if (endDate == 'Invalid date') return;
            const { data } = await api.get(uri, {
                params: {
                    startDate: startDate,
                    endDate: endDate,
                    centerId: this.centerId,
                    centerProductId: this.selectedProduct.centerProductId,
                    centerContractId: this.selectedProduct.centerContractId,
                },
            });

            this.exteriorPlan = data.lessonSchedule
                .filter((v) => v.cls_schd_type_cd == 'M')
                .filter((v2) => v2.cls_less_staff_id == this.selectedTeacher && v2.cls_less_dt == this.lessonDate)
                .reduce((x, y) => {
                    const s = Utils.getTimes(
                        y.cls_less_start_tm,
                        y.cls_less_end_tm,
                        timeUnitValue,
                        this.selectedProduct.centerProduct.lessonTime
                    );
                    return x.concat(s);
                }, []);

            for (let i = 0; i < this.exteriorPlan.length; i++) {
                this.exteriorPlan[i] = parseInt(this.exteriorPlan[i].replace(':', ''));
                let tempTime,
                    tempMin = '';
                tempTime = this.selectFormStartHour.selectedValue;
                tempMin = this.selectFormStartMin.selectedValue;
                if (this.exteriorPlan[i] === parseInt(tempTime + tempMin) && i !== this.exteriorPlan.length - 1) {
                    this.lessonTimeAlertMsg = '수업 및 일정이 이미 있습니다.';
                    return;
                } else {
                    this.lessonTimeAlertMsg = '';
                }
            }
        },
        async timeFetch() {
            const { selectFormStartHour, selectFormStartMin } = this;
            // initialize
            // (selectFormStartHour.data = []), (selectFormStartHour.value = []);
            (selectFormStartMin.data = []), (selectFormStartMin.value = []);

            // 20220404 주석처리.. 부모 컴포넌트에서 전달받은 데이터까지 초기화 함..;
            let data = '';
            try {
                // 20220404 부모컴포넌트에서 받은 스케줄시간을 가지고 중복예약이 있는지 체크한다.
                data = await this.getLessonScheduleDuplicateCustomer();
                if (data.data) {
                    this.lessonTimeAlertMsg = '해당 시간은 이미 예약된 내역이 있어 중복예약됩니다.';
                } else {
                }
            } catch {
                // 스케줄 매뉴를 통해 들어오지 않으면 부모에서 주는 데이터가 없어 에러가 난다..
                // 초기화한다.
                (selectFormStartHour.selectedValue = ''), (selectFormStartMin.selectedValue = '');
            }
            // 회원이 같은시간에 예약이 있을경우...

            // 수업시작 시간 : 시
            // for (let h = 0; h < 24; h++) {
            //     let hour = h.toString().padStart(2, '0');
            //     selectFormStartHour.data.push(hour);
            //     selectFormStartHour.value.push(hour);
            // }
            // 수업시작 시간 : 분
            const timeUnitValue = this.reservationSetting.timeUnitValue;
            if (timeUnitValue < 60) {
                for (let m = 0; m < 60; m += timeUnitValue) {
                    let min = m.toString().padStart(2, '0');
                    selectFormStartMin.data.push(min);
                    selectFormStartMin.value.push(min);
                }
            } else {
                selectFormStartMin.data.push('00');
                selectFormStartMin.value.push('00');
            }
        },
        async fetchReservationSetting() {
            const { data } = await this.getCenterReservSetting();
            this.reservationSetting = data;
        },
        async fetchCustomerProductTicket() {
            if (Utils.isEmpty(this.selectedCustomer.id)) {
                return false;
            }

            try {
                const { data: contractData } = await this.getCustomerProductTicket(this.selectedCustomer.id);
                const data = contractData.filter((con) => {
                    return moment(moment(con.expireEndDt).add(1, 'day')).isAfter();
                });

                this.selectFormCustomerProduct.data = ['이용권 선택'];
                this.selectFormCustomerProduct.value = [''];
                this.selectFormCustomerProduct.list = [...data];

                // if (!data || data.length === 0) {
                //     alert('유효한 이용권이 존재하지 않습니다.');
                //     return;
                // }

                let len = data.length;
                for (let i = 0; i < len && data[i].centerProduct.ticketType != 'T'; i++) {
                    let d = data[i];
                    // if(d.centerProduct.ticketType == 'C' || d.centerProduct.ticketType =='G'){
                    //     // 티켓타입이 그룹이나 쿠폰인경우 제외
                    //     continue;
                    // }
                    if (Utils.isEmpty(d.centerProduct)) {
                        // 데이터 정합성 오류 : 상품 정보 없음
                        continue;
                    }
                    // else if(d.lessonJoinCount + d.lessonAbsentCount === d.lessonCount) {
                    //     // 횟수가 모두 차감된 경우
                    //     continue;
                    // }

                    let typeName = Utils.getTicketTypeName(d.centerProduct.ticketType);
                    let productName = `[${typeName}] ${d.productName} (${d.lessonResvCount}/${d.lessonCount}) ${d.expireStartDt} ~ ${d.expireEndDt}`;
                    this.selectFormCustomerProduct.data.push(productName);
                    this.selectFormCustomerProduct.value.push(i);
                }
                // console.log(this.selectFormCustomerProduct);
            } catch (e) {
                console.error(e);
            }
        },
        updateEditFieldReservSelectedTeacher(val) {
            this.checkSchedule();
            this.checkExteriorPlanNew();
            this.selectedTeacher = val;
            // 이미 수업시간 관련 단계로 넘어왔던 이력 존재.
            // 20220404 this.timeFetch로직에 무조건 회원명이 필요하여 if문으로 감쌈...
            //
            if (this.selectedCustomer.id !== '') {
                if (this.selectFormStartMin.data.length > 0) this.timeFetch();

                if (Utils.isEmpty(val)) {
                    this.step = this.EDIT_STEP.TEACHER;
                } else {
                    this.goNextEditStep();
                }
            }
        },
        onClickBtnOpenSearchCustomer() {
            if (this.isModify) {
                return false;
            }

            this.memberPop = true;
        },
        onClickBtnCancelReservation() {
            if (!Utils.isEmpty(this.callbackCancel)) {
                this.callbackCancel();
            }
            this.resetData();
        },
        async onClickBtnRegistReservation() {
            if (!this.isAllowed('SC', 1) && this.selectedTeacher !== this.staffId) {
                alert('사용권한이 없습니다. 대표관리자에게 권한을 요청하세요.');
                return false;
            }

            // 값 체크 및 확인
            if (!this.validateReservationValue() || !confirm('예약을 등록하시겠습니까?')) {
                return;
            }

            // 등록
            const params = this.getParams();
            for (const param of params) {
                try {
                    await this.postLessonScheduleCustomer(param).then((res) => {
                        if (res.status == 200) {
                            if (!Utils.isEmpty(this.callbackSuccess)) {
                                this.callbackSuccess(res.data);
                                this.resetData();
                            }
                        } else {
                            alert('오류가 발생하였습니다.');
                        }
                    });
                } catch (e) {
                    Utils.alertResponseErrorMessge(e);
                    // alert(e.response.data.message);
                }
            }
        },
        async onClickBtnModifyReservation() {
            if (!this.isAllowed('SC', 1) && this.selectedTeacher !== this.staffId) {
                alert('사용권한이 없습니다. 대표관리자에게 권한을 요청하세요.');
                return false;
            }

            // 값 체크 및 확인
            if (!this.validateReservationValue()) {
                return;
            }

            if (!confirm('예약을 수정하시겠습니까?')) {
                return;
            }

            // 수정
            const params = this.getParams();
            try {
                const { data } = await this.putLessonScheduleCustomer(params[0], this.centerLessonScheduleId);

                if (!Utils.isEmpty(data) && !Utils.isEmpty(data.centerLessonScheduleId)) {
                    if (!Utils.isEmpty(this.callbackSuccess)) {
                        this.callbackSuccess(data);
                        this.resetData();
                    }
                } else {
                    alert('오류가 발생하였습니다.');
                }
            } catch (e) {
                Utils.alertResponseErrorMessge(e);
                console.error(e);
            }
        },
        async onClickBtnDeleteReservation() {
            if (!this.isAllowed('SC', 1) && this.selectedTeacher !== this.staffId) {
                alert('사용권한이 없습니다. 대표관리자에게 권한을 요청하세요.');
                return false;
            }

            // @TODO: 예약 삭제
            if (confirm('예약을 취소하시겠습니까?')) {
                try {
                    const { centerLessonScheduleMasterId, centerLessonScheduleId, selectedCustomer } = this;
                    let params = {
                        scheduleMasterId: centerLessonScheduleMasterId,
                        scheduleId: centerLessonScheduleId,
                        customerId: selectedCustomer.id,
                        attendanceDevice: 'AW',
                        scheduleCancelReason: '',
                    };

                    await this.deleteLessonSchedule(params);

                    if (!Utils.isEmpty(this.callbackSuccess)) {
                        this.callbackSuccess();
                        this.resetData();
                    }
                } catch (e) {
                    console.error(e);
                    Utils.alertResponseErrorMessge(e);
                }
            }
        },
        onSelectSearchCustomerDlg(customer) {
            // console.log(customer);
            this.selectedCustomer = {
                id: customer.center_cust_id,
                name: customer.name,
            };

            this.memberPop = false;

            this.fetchCustomerProductTicket();

            this.goNextEditStep();
        },
        onCancelSearchCustomerDlg() {
            this.memberPop = false;
        },
        deleteLessonSchedule(params) {
            // scheduleMasterId, scheduleId, customerId, attendanceDevice, scheduleCancelReason
            // /admin/api/center/{centerId}/lesson/schedule/cancelLesson
            return api.delete(`/admin/api/center/${this.centerId}/lesson/schedule/cancelLesson`, { params });
        },
        async updateLessonDate(date) {
            if (Utils.isEmpty(date)) {
                // resetDate 호출 후, 자식으로부터 재호출 되는 경우를 막는다.
                return;
            }

            if (this.step <= this.EDIT_STEP.CUSTOMER) {
                // 테이블을 선택하여 창을 띄워 초기화된 경우
                return;
            }
            await this.checkSchedule();
            this.checkExteriorPlanNew();
            this.checkLessonDateNew(date);
            this.checkLessonCountNew(date);
            this.timeFetchNew();
            // this.updateRoomTime();
            this.generateEditFieldRoomInfo();
        },
        async updateReserveHour(hour) {
            this.selectFormStartHour.selectedValue = hour;
            await this.checkSchedule();
            this.checkExteriorPlan();
            this.checkReserveTime();
            this.checkLessonCount(this.lessonDate);
            // this.updateRoomTime();
            this.generateEditFieldRoomInfo();
        },
        async updateReserveMin(min) {
            this.selectFormStartMin.selectedValue = min;
            await this.checkSchedule();
            this.checkExteriorPlan();
            this.checkReserveTime();
            this.checkLessonCount(this.lessonDate);
            // this.updateRoomTime();
            this.generateEditFieldRoomInfo();
        },
        updateEditFieldReservCenterRoom(val, room, index) {
            const roomInfo = this.selectFormRoom[index].room[val];
            try {
                if (roomInfo && !roomInfo.reserveYn) {
                    alert('현재 미사용중인 센터룸입니다.');
                    return false;
                } else if (roomInfo && roomInfo.totalCount > roomInfo.limitCount) {
                    if (roomInfo.limitYn) {
                        if (
                            roomInfo.centerRoomId != this.presetRooms[0].centerRoomId ||
                            roomInfo.centerRoomId != this.presetRooms[1].centerRoomId
                        ) {
                            alert('선택 할 수 없는 룸입니다.');
                            return false;
                        }
                    }
                } else if (roomInfo && roomInfo.totalCount === roomInfo.limitCount) {
                    if (roomInfo.limitYn) {
                        alert('이미 사용중인 룸입니다.');
                        val = '';
                        return false;
                    }
                }
            } catch (e) {
                console.log(e);
                val = '';
            }
            room.centerRoomId = val;
        },
        async fetchSelectFormCenterRoom(useStartTime, useEndTime, index) {
            const { data } = await this.getCenterRoomReservation(useStartTime, useEndTime);

            const obj = {
                data: [],
                value: [],
            };
            const roomsMap = {};

            let selectRoom1;
            let selectRoom2;
            let selectRoomName1 = '';
            let selectRoomName2 = '';
            if (this.presetRooms[0]) {
                selectRoom1 = this.presetRooms[0].centerRoomId;
            }
            if (this.presetRooms[1]) {
                selectRoom2 = this.presetRooms[1].centerRoomId;
            }
            for (const item of data) {
                let title = item.name;
                if (!item.reserveYn) {
                    // title = `${title} (미사용)`;
                    continue;
                } else if (item.limitYn && !Utils.isEmpty(item.totalCount)) {
                    // if (item.totalCount == item.limitCount) {
                    //
                    //     for (const room of this.presetRooms) {
                    //         console.log("room.centerRoomId === item.centerRoomId",room.centerRoomId === item.centerRoomId);
                    //         if ((room.centerRoomId === selectRoom1) && (room.centerRoomId === item.centerRoomId)) {
                    //             selectRoomName1 = `${title} (${item.totalCount}/${item.limitCount})`;
                    //         }
                    //         if ((room.centerRoomId === selectRoom2) && (room.centerRoomId === item.centerRoomId)) {
                    //             selectRoomName2 = `${title} (${item.totalCount}/${item.limitCount})`;
                    //         }
                    //     }
                    //     if (selectRoomName1) {
                    //         obj.data.push(selectRoomName1);
                    //         obj.value.push(selectRoom1);
                    //     }
                    //     if (selectRoomName2) {
                    //         obj.data.push(selectRoomName2);
                    //         obj.value.push(selectRoom2);
                    //     }
                    //     roomsMap[item.centerRoomId] = item;
                    //     continue;
                    // } else {
                    title = `${title} (${item.totalCount}/${item.limitCount})`;
                    // }
                }

                obj.data.push(title);
                obj.value.push(item.centerRoomId);
                roomsMap[item.centerRoomId] = item;
            }
            this.selectFormRoom[index] = {
                data: ['선택 안함', ...obj.data],
                value: ['', ...obj.value],
                room: { ...roomsMap },
            };
        },
        async setReservCustomerProduct(val) {
            const { selectFormCustomerProduct } = this;

            selectFormCustomerProduct.selectedValue = val;

            await this.checkSchedule();

            const product = selectFormCustomerProduct.list[val];

            // console.log('selectFormCustomerProduct', selectFormCustomerProduct.list[val]);

            this.selectedProduct = product;

            this.checkExteriorPlan();

            if (Utils.isEmpty(product)) {
                this.step = this.EDIT_STEP.TICKET;
            } else {
                this.selectFormLessonTime.selectedValue = product.centerProduct.lessonTime
                    ? product.centerProduct.lessonTime
                    : 60;
                await this.generateEditFieldRoomInfo();
                this.goNextEditStep();
            }
            // 수업일자가 셋팅되어있다면, 날짜 체크
            if (!Utils.isEmpty(this.lessonDate)) {
                this.checkLessonDate(this.lessonDate);

                // 20220404
                // 스케줄 -> 일일스케줄 -> 스케줄 예약시 이용권을 선택시 수업시간을 표현하기 위해 추가.
                this.timeFetch();

                this.checkLessonCount(this.lessonDate);
            }
        },
        getCustomerProductTicket(customerId = '') {
            // 스웨거 검색: 회원의 이용권(비 그룹레슨) 목록조회
            return api.get(`/admin/api/center/${this.centerId}/customer/ticketList/notGroup/${customerId}`);
        },
        getCenterReservSetting() {
            return api.get(`/admin/api/center/${this.centerId}/reservation-setting`);
        },
        getCenterRooms() {
            return api.get(`/admin/api/centerRoom/${this.centerId}`);
        },
        getCenterRoomReservation(useStartTime, useEndTime) {
            const { centerId, lessonDate, centerLessonScheduleId } = this;
            // 스웨거 검색: 룸 예약 현황 조회
            return api.get(`/admin/api/centerRoom/reservation/status`, {
                params: {
                    centerId,
                    lessonDate,
                    useStartTime,
                    useEndTime,
                    centerLessonScheduleId,
                },
            });
        },
        getLessonScheduleDuplicateCustomer() {
            const {
                lessonDate,
                selectFormLessonTime,
                selectFormStartHour,
                selectFormStartMin,
                selectedCustomer,
                centerLessonScheduleId,
            } = this;

            const centerCustomerId = selectedCustomer.id;
            const tmFormat = 'HH:mm:ss';
            const dtFormat = 'YYYY-MM-DD HH:mm:ss';

            if (selectFormStartHour.selectedValue == '') {
                return;
            } else if (selectFormStartMin.selectedValue == '') {
                return;
            }
            const startTime = `${selectFormStartHour.selectedValue}:${selectFormStartMin.selectedValue}:00`;

            let lessonStartDatetime = `${lessonDate} ${startTime}`;

            const endTime = moment(lessonStartDatetime, dtFormat)
                .add(selectFormLessonTime.selectedValue, 'minutes')
                .format(tmFormat);

            const params = {
                centerCustomerId,
                centerLessonScheduleId,
                lessonDate,
                startTime,
                endTime,
            };

            // @스웨거 검색: 스케줄 시간 중복 체크
            return api.get(`/admin/api/center/${this.centerId}/lesson/schedule/duplicate/customer`, { params });
        },
        postLessonScheduleCustomer(param, centerLessonScheduleId = 0) {
            // @스웨거검색: 회원 수업 스케줄 예약하기(개인/OT/듀엣)
            const { selectedCustomer } = this;
            return api.post(
                `/admin/api/center/${this.centerId}/lesson/schedule/${centerLessonScheduleId}/customer/${param.centerCustomerId}`,
                { ...param }
            );
        },
        putLessonScheduleCustomer(params, centerLessonScheduleId = 0) {
            // @스웨거검색: 회원 수업 스케줄 수정하기(개인/OT/듀엣)
            const { selectedCustomer } = this;
            return api.put(
                `/admin/api/center/${this.centerId}/lesson/schedule/${centerLessonScheduleId}/customer/${selectedCustomer.id}`,
                { ...params }
            );
        },
        getDailyScheduleCustomerContract(centerCustomerId, centerLessonScheduleId) {
            const params = {
                centerLessonScheduleId,
            };

            return api.get(
                `/admin/api/center/${this.centerId}/lesson/schedule/daily/customer/${centerCustomerId}/contract`,
                { params }
            );
        },
        async generateEditFieldRoomInfo() {
            const dtFormat = 'YYYY-MM-DD HH:mm:ss';
            const tmFormat = 'HH:mm';
            const { lessonDate, selectFormStartHour, selectFormStartMin, selectFormLessonTime } = this;

            if (
                Utils.isEmpty(lessonDate) ||
                Utils.isEmpty(selectFormStartHour.selectedValue) ||
                Utils.isEmpty(selectFormStartMin.selectedValue)
            ) {
                return;
            }

            const lessonStartTime = moment(
                `${lessonDate} ${selectFormStartHour.selectedValue}:${selectFormStartMin.selectedValue}:00`,
                dtFormat
            );

            const len = selectFormLessonTime.selectedValue / 30;

            this.selectFormRoom = [];
            this.rooms = [];
            // console.log('len', len, selectFormLessonTime.selectedValue);
            for (let i = 0; i < len; i++) {
                const useStartTime = lessonStartTime.format(tmFormat);
                const useEndTime = lessonStartTime.add(30, 'minutes').format(tmFormat);
                this.selectFormRoom.push({
                    data: [],
                    value: [],
                });

                await this.fetchSelectFormCenterRoom(useStartTime, useEndTime, i);
                /*
        console.log('{\n' +
            '                    centerRoomId: \'\',\n' +
            '                    useStartTime,\n' +
            '                    useEndTime,\n' +
            '                }', {
          centerRoomId: '',
          useStartTime,
          useEndTime,
        });
        */
                this.rooms.push({
                    centerRoomId: '',
                    useStartTime,
                    useEndTime,
                });
            }

            // 기존 센터룸예약 정보 입력
            if (!Utils.isEmpty(this.presetRooms)) {
                const roomResvMap = this.presetRooms.reduce((acc, it) => ({ ...acc, [it.useStartTime]: it }), {});
                for (let i = 0; i < this.rooms.length; i++) {
                    const room = this.rooms[i];
                    if (
                        !Utils.isEmpty(roomResvMap[room.useStartTime]) &&
                        roomResvMap[room.useStartTime].lessonDate == this.lessonDate
                    ) {
                        room.centerRoomId = roomResvMap[room.useStartTime].centerRoomId;
                    }
                }
            }

            // this.fetchCenterRooms();
        },
        /*
    async generateOnlySelectFormRoom(){
        const dtFormat = 'YYYY-MM-DD HH:mm:ss';
        const tmFormat = 'HH:mm';
        const { lessonDate, selectFormStartHour, selectFormStartMin, selectFormLessonTime } = this;

        if (Utils.isEmpty(lessonDate)) {
            return;
        }

        const lessonStartTime = moment(`${lessonDate} ${selectFormStartHour.selectedValue}:${selectFormStartMin.selectedValue}:00`, dtFormat);
        const len = selectFormLessonTime.selectedValue / 30;

        this.selectFormRoom = [];

        for (let i = 0; i < len; i++) {
            const useStartTime = lessonStartTime.format(tmFormat);
            const useEndTime = lessonStartTime.add(30, 'minutes').format(tmFormat);
            this.selectFormRoom.push({
                data: [],
                value: [],
            });

            await this.fetchSelectFormCenterRoom(useStartTime, useEndTime, i);
        }

        this.fetchCenterRooms();
    },
     */
        getParams() {
            let params = [];

            const dtFormat = 'YYYY-MM-DD HH:mm:ss';
            const { lessonDate } = this;
            const lessonStartTime = `${lessonDate} ${this.selectFormStartHour.selectedValue}:${this.selectFormStartMin.selectedValue}:00`;
            const lessonEndTime = moment(lessonStartTime, dtFormat)
                .add(this.selectFormLessonTime.selectedValue, 'minutes')
                .format(dtFormat);
            const centerLessonScheduleMasterId = this.isModify ? this.centerLessonScheduleMasterId : 0;

            // 멀티 등록
            for (const ticket of this.selectedTicketValueList) {
                const param = {
                    centerLessonScheduleMasterId,
                    reservationDevice: 'AW', // 등록 디바이스 고정값 (관리자웹 [ 관리자웹 : AW, 관리자앱 : AA, 회원앱 : CA, 터치모니터 : TU ])
                    reservationType: 'S', // 등록 주체 구분 고정값 ([직원 : S, 회원 : M])
                    reservationId: this.staffId, // 등록자 아이디
                    centerContractId: ticket.centerContractId,
                    centerProductId: ticket.centerProductId,
                    centerCustomerId: ticket.centerCustomerId,
                    centerCustomerName: ticket.centerCustomer.name,
                    lessonStaffId: this.selectedTeacher,
                    dayOfWeek: Utils.getDayOfWeekName(this.lessonDate),
                    lessonDate,
                    lessonStartTime: lessonStartTime.split(' ')[1],
                    lessonEndTime: lessonEndTime.split(' ')[1],
                    lessonsType: ticket.centerProduct.ticketType,
                    memo: this.memo !== null ? this.memo.trim() : '',
                    roomInfos: [],
                };

                for (let r of this.rooms) {
                    if (!Utils.isEmpty(r.centerRoomId)) {
                        param.roomInfos.push({
                            centerRoomId: r.centerRoomId,
                            useStartTime: r.useStartTime,
                            useEndTime: r.useEndTime,
                        });
                    }
                }

                params.push(param);
            }

            return params;
        },
        async checkLessonScheduleDuplicate() {
            // 전송 조건 확인
            const { lessonDate, selectFormStartHour, selectFormStartMin, selectedCustomer } = this;
            if (
                Utils.isEmpty(lessonDate) ||
                Utils.isEmpty(selectFormStartHour.selectedValue) ||
                Utils.isEmpty(selectFormStartMin.selectedValue) ||
                Utils.isEmpty(selectedCustomer.id)
            ) {
                return false;
            }

            try {
                const { data } = await this.getLessonScheduleDuplicateCustomer();
                if (data) {
                    this.lessonTimeAlertMsg = '해당 시간은 이미 예약된 내역이 있어 중복예약됩니다.';
                }
            } catch (e) {
                console.error(e);
            }
        },
        checkLessonDate(date) {
            let product = this.selectedProduct;

            if (Utils.isEmpty(product) || Utils.isEmpty(product.expireStartDt) || Utils.isEmpty(product.expireEndDt)) {
                this.lessonDate = '';
                this.$refs.lessonDate.resetDate();

                alert('이용권을 선택해주세요.');
                return false;
            }

            const limitDate = this.checkTeacherReservDatetime(date, `${this.selectFormStartHour.selectedValue}:${this.selectFormStartMin.selectedValue}:00`);
            if (!this.isAllowed('LE', 6) && !limitDate.result) {
                this.lessonDate = '';
                this.$refs.lessonDate.resetDate();

                this.lessonTimeAlertMsg = `예약 가능시간이 아닙니다.\n${limitDate.date} 이후 날짜를 선택해주세요.`;
                this.step = this.EDIT_STEP.LESSON_TIME;
            } else if (!Utils.isDateInRange(date, product.expireStartDt, product.expireEndDt)) {
                this.lessonDate = '';
                this.$refs.lessonDate.resetDate();

                this.lessonTimeAlertMsg = '유효기간 내의 날짜로 선택해주세요.';
                this.step = this.EDIT_STEP.LESSON_DATE;
            } else {
                if (this.lessonDate !== date) {
                    this.lessonTimeAlertMsg = '';
                    this.lessonDate = date;
                }
                // this.lessonTimeAlertMsg = '';

                this.goNextEditStep();
            }
        },
        checkTeacherReservDatetime(date, time = '') {
            // 기본값 셋팅
            const now = moment();
            let dFormat = 'YYYY-MM-DD';
            let reservDate = date;

            if (!Utils.isEmpty(time)) {
                reservDate = `${date} ${time}:00`;
                dFormat = `${dFormat} HH:mm:ss`;
            }

            // 오늘 이후 이면
            if (moment(reservDate, dFormat).isSame(now) || moment(reservDate, dFormat).isAfter(now)) {
                return { result: true };
            }

            // 예약 가능 설정
            const { ticketType } = this.selectedProduct.centerProduct;
            let dtStr = '';
            switch (ticketType) {
                case 'P':
                case 'O':
                    dtStr = this.reservationSetting.teacherReservationOt;
                    break;
                case 'D':
                    dtStr = this.reservationSetting.teacherReservationDu;
                    break;
                case 'G':
                    dtStr = this.reservationSetting.teacherReservationGr;
                    break;
            }

            if (Utils.isEmpty(dtStr)) {
                // 설정이 되어있지 않으면
                return { result: true };
            }

            // 날짜 체크. 이전 날짜이면 예약 불가
            // 에약 가능한 최대 날짜 산출
            const [day, hour, min] = dtStr.split('-');

            // 0일 0시 0분으로 세팅되어 있으면 그냥 통과 시킨다.
            if (day == 0 && hour == 0 && min == 0) {
                return { result: true };
            }

            let limitDate = moment().subtract(parseInt(day), 'days');
            if (!Utils.isEmpty(time)) {
                limitDate.subtract(parseInt(hour), 'hours').subtract(parseInt(min), 'minutes');
            }

            // 예약 가능일 이후 부터 현재까지의 범위 안에 예약일시가 있어야 예약 가능
            let result = {
                result: moment(reservDate).isAfter(limitDate),
                date: limitDate.format(dFormat),
            };
            return result;
        },
        checkReserveTime() {
            // 강사가 예약 가능한 시간인지 확인하여 알림
            const { lessonDate, selectFormStartHour, selectFormStartMin } = this;

            if (Utils.isEmpty(selectFormStartHour.selectedValue) || Utils.isEmpty(selectFormStartMin.selectedValue)) {
                // 시간 값이 설정이 되어있지 않는 경우, 체크하지 않는다.
                return { result: true };
            }

            let lessonTime = `${selectFormStartHour.selectedValue}:${selectFormStartMin.selectedValue}`;
            const limitResult = this.checkTeacherReservDatetime(lessonDate, lessonTime);

            if (!this.isAllowed('LE', 6) && !limitResult.result) {
                this.lessonTimeAlertMsg = `예약 가능시간이 아닙니다.\n${limitResult.date} 이후 시간을 선택해주세요.`;
                return;
            }

            // this.lessonTimeAlertMsg = '';
            this.checkLessonScheduleDuplicate();
        },
        async checkSchedule() {
            let targetDate = moment(this.lessonDate).format('YYYYMMDD');
            if (targetDate == 'Invalid date') return;
            if (!this.selectedTeacher) return;
            await api
                .get(`/admin/api/center/${this.centerId}/lesson/schedule/daily/all`, {
                    params: {
                        staffIdList: this.selectedTeacher,
                        targetDate,
                    },
                })
                .then((response) => {
                    for (let i = 0; i < response.data.length; i++) {
                        let start,
                            startMin,
                            end,
                            endMin,
                            tempTime,
                            tempMin = 0;

                        start = response.data[i].lessonStartTime.substr(0, 2);
                        startMin = response.data[i].lessonStartTime.substr(3, 4);
                        end = response.data[i].lessonEndTime.substr(0, 2);
                        endMin = response.data[i].lessonEndTime.substr(3, 4);
                        tempTime = this.selectFormStartHour.selectedValue;
                        tempMin = this.selectFormStartMin.selectedValue;

                        let from = start + startMin;
                        from = parseInt(from);
                        let to = end + endMin;
                        to = parseInt(to);
                        let com = tempTime + tempMin;
                        com = parseInt(com);
                        if (response.data[i].scheduleType === 'M') {
                            this.hasSchedule = true;
                        }
                        if (from <= com) {
                            if (to > com) {
                                this.lessonTimeAlertMsg = '수업 및 일정이 이미 있습니다.';
                                break;
                            } else {
                                this.lessonTimeAlertMsg = '';
                            }
                        } else {
                            this.lessonTimeAlertMsg = '';
                        }
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        validateReservationValue() {
            if (Utils.isEmpty(this.selectedTeacher)) {
                alert('강사를 선택해주세요');
                return false;
                /*
      } else if (Utils.isEmpty(this.selectedCustomer.name)) {
        alert('회원을 선택해주세요');
        return false;
      } else if (Utils.isEmpty(this.selectedProduct)) {
        alert('이용권을 선택해주세요');
        return false;
      */
            } else if (Utils.isEmpty(this.lessonDate)) {
                alert('수업일자를 선택해주세요');
                return false;
            } else if (
                Utils.isEmpty(this.selectFormStartHour.selectedValue) ||
                Utils.isEmpty(this.selectFormStartMin.selectedValue)
            ) {
                alert('수업시작시간을 선택해주세요');
                return false;
            } else if (
                !Utils.isEmpty(this.lessonTimeAlertMsg) &&
                this.lessonTimeAlertMsg !== '해당 시간은 이미 예약된 내역이 있어 중복예약됩니다.' &&
                this.lessonTimeAlertMsg !== '수업 및 일정이 이미 있습니다.'
            ) {
                alert('수업일자/시간을 확인해주세요');
                return false;
            } else if (this.selectedTicketList.length < 1) {
                alert('회원을 선택해주세요');
                return false;
            }

            return true;
        },
        goNextEditStep() {
            const { EDIT_STEP } = this;
            switch (this.step) {
                case EDIT_STEP.TEACHER:
                    if (!Utils.isEmpty(this.selectedTeacher)) {
                        this.step = EDIT_STEP.CUSTOMER;
                    } else {
                        return false;
                    }
                    break;
                case EDIT_STEP.CUSTOMER:
                    if (!Utils.isEmpty(this.selectedCustomer.id)) {
                        this.step = EDIT_STEP.TICKET;
                    } else {
                        return false;
                    }
                    break;
                case EDIT_STEP.TICKET:
                    // if (!Utils.isEmpty(this.selectedProduct)) {
                    if (this.selectedTicketValueList.length > 0) {
                        this.step = EDIT_STEP.LESSON_DATE;
                    } else {
                        return false;
                    }
                    break;
                case EDIT_STEP.LESSON_DATE:
                    if (!Utils.isEmpty(this.lessonDate)) {
                        this.step = EDIT_STEP.LESSON_TIME;
                    } else {
                        return false;
                    }
                    break;
                case EDIT_STEP.LESSON_TIME:
                    if (
                        !Utils.isEmpty(this.selectFormStartHour) &&
                        !Utils.isEmpty(this.selectFormStartMin) &&
                        (Utils.isEmpty(this.lessonTimeAlertMsg) ||
                            this.lessonTimeAlertMsg == '수업 및 일정이 이미 있습니다.')
                    ) {
                        this.step = EDIT_STEP.ROOM_MEMO;
                    } else {
                        return false;
                    }
                    break;
                case EDIT_STEP.ROOM_MEMO: // 마지막 단계
                    return false;
            }

            this.goNextEditStep();
        },
        resetData() {
            this.step = 1;
            this.isModify = false;
            this.lessonTimeAlertMsg = '';
            this.selectedTeacher = '';
            this.selectedCustomer = {
                name: '',
                id: '',
            };

            this.selectedProduct = null;
            this.lessonDate = '';
            // this.lessonDate = moment().format('YYYY-MM-DD'); //등록후 초기화되면 오늘날짜로

            this.selectFormCustomerProduct = {
                list: [],
                data: [],
                value: [],
                selectedValue: '',
            };
            this.selectFormStartHour.selectedValue = '';
            this.selectFormStartMin.selectedValue = '';

            this.selectFormLessonTime.selectedValue = 60;
            this.memo = '';
            this.rooms = [];

            this.centerContractBillTicketNameList = [];
            this.centerContractBillTicketValueList = [];
            this.selectedTicketList = [];
            this.selectedTicketValueList = [];
        },
        show() {
            this.isShow = true;
        },
        hide() {
            this.isShow = false;
        },
        isEmpty(v) {
            return Utils.isEmpty(v);
        },
        async checkLessonCount(lessonDate) {
            if (this.isModify) {
                return true;
            }

            let centerCustomerId = 0;
            let centerContractId = 0;
            let centerProductId = 0;

            if (this.isFixedContract) {
                centerCustomerId = this.$parent.centerCustomerId;
                centerContractId = this.$parent.centerContractId;
                centerProductId = this.$parent.centerProductId;
            } else {
                centerCustomerId = this.selectedProduct.centerCustomerId;
                centerContractId = this.selectedProduct.centerContractId;
                centerProductId = this.selectedProduct.centerProductId;
            }

            // 스웨거 검색: 수업횟수 확인
            const { data } = await api.get(`/admin/api/center/${this.centerId}/lesson/schedule/check/less/count/over`, {
                params: {
                    centerCustomerId,
                    centerContractId,
                    centerProductId,
                    lessonDate: moment(lessonDate).format('YYYYMMDD'),
                },
            });

            // this.isCheckOver = data.result;
            if (data.result) {
                this.lessonTimeAlertMsg = '예약가능한 수업횟수를 모두 사용하였습니다.';
            }
        },
        async checkExteriorPlanNew() {
            for (const ticket of this.selectedTicketValueList) {
                const uri = `/admin/api/customer-app/center/${this.centerId}/customer/${ticket.centerCustomerId}/lesson/person/category/schedule`;
                const date = moment(this.lessonDate);
                const startDate = date.startOf('month').format('YYYY-MM-DD');
                const endDate = date.endOf('month').format('YYYY-MM-DD');

                if (startDate == 'Invalid date') return;
                if (endDate == 'Invalid date') return;
                const { data } = await api.get(uri, {
                    params: {
                        startDate: startDate,
                        endDate: endDate,
                        centerId: this.centerId,
                        centerProductId: ticket.centerProductId,
                        centerContractId: ticket.centerContractId,
                    },
                });

                this.exteriorPlan = data.lessonSchedule
                    .filter((v) => v.cls_schd_type_cd == 'M')
                    .filter((v2) => v2.cls_less_staff_id == this.selectedTeacher && v2.cls_less_dt == this.lessonDate)
                    .reduce((x, y) => {
                        const s = Utils.getTimes(
                            y.cls_less_start_tm,
                            y.cls_less_end_tm,
                            timeUnitValue,
                            ticket.centerProduct.lessonTime
                        );
                        return x.concat(s);
                    }, []);

                for (let i = 0; i < this.exteriorPlan.length; i++) {
                    this.exteriorPlan[i] = parseInt(this.exteriorPlan[i].replace(':', ''));
                    let tempTime,
                        tempMin = '';
                    tempTime = this.selectFormStartHour.selectedValue;
                    tempMin = this.selectFormStartMin.selectedValue;
                    if (this.exteriorPlan[i] === parseInt(tempTime + tempMin) && i !== this.exteriorPlan.length - 1) {
                        this.lessonTimeAlertMsg = '수업 및 일정이 이미 있습니다.';
                        return;
                    } else {
                        this.lessonTimeAlertMsg = '';
                    }
                }
            }
        },
        checkLessonDateNew(date) {
            if (this.selectedTicketValueList.length < 1) {
                this.lessonDate = '';
                this.$refs.lessonDate.resetDate();

                alert('이용권을 선택해주세요.');
                return false;
            }

            for (const ticket of this.selectedTicketValueList) {
                const limitDate = this.checkTeacherReservDatetimeNew(date, `${this.selectFormStartHour.selectedValue}:${this.selectFormStartMin.selectedValue}:00`);
                if (!this.isAllowed('LE', 6) && !limitDate.result) {
                    this.lessonDate = '';
                    this.$refs.lessonDate.resetDate();

                    this.lessonTimeAlertMsg = `예약 가능시간이 아닙니다.\n${limitDate.date} 이후 날짜를 선택해주세요.`;
                    this.step = this.EDIT_STEP.LESSON_TIME;
                } else if (!Utils.isDateInRange(date, ticket.expireStartDt, ticket.expireEndDt)) {
                    this.lessonDate = '';
                    this.$refs.lessonDate.resetDate();

                    this.lessonTimeAlertMsg = '유효기간 내의 날짜로 선택해주세요.';
                    this.step = this.EDIT_STEP.LESSON_DATE;
                } else {
                    if (this.lessonDate !== date) {
                        this.lessonTimeAlertMsg = '';
                        this.lessonDate = date;
                    }
                    // this.lessonTimeAlertMsg = '';

                    this.goNextEditStep();
                }
            }
        },
        checkTeacherReservDatetimeNew(date, time = '') {
            // 기본값 셋팅
            const now = moment();
            let dFormat = 'YYYY-MM-DD';
            let reservDate = date;

            if (!Utils.isEmpty(time)) {
                reservDate = `${date} ${time}:00`;
                dFormat = `${dFormat} HH:mm:ss`;
            }

            // 오늘 이후 이면
            if (moment(reservDate, dFormat).isSame(now) || moment(reservDate, dFormat).isAfter(now)) {
                return { result: true };
            }

            for (const ticket of this.selectedTicketValueList) {
                // 예약 가능 설정
                const { ticketType } = ticket.centerProduct;
                let dtStr = '';
                switch (ticketType) {
                    case 'P':
                    case 'O':
                        dtStr = this.reservationSetting.teacherReservationOt;
                        break;
                    case 'D':
                        dtStr = this.reservationSetting.teacherReservationDu;
                        break;
                    case 'G':
                        dtStr = this.reservationSetting.teacherReservationGr;
                        break;
                }

                if (Utils.isEmpty(dtStr)) {
                    // 설정이 되어있지 않으면
                    return { result: true };
                }

                // 날짜 체크. 이전 날짜이면 예약 불가
                // 에약 가능한 최대 날짜 산출
                const [day, hour, min] = dtStr.split('-');

                // 0일 0시 0분으로 세팅되어 있으면 그냥 통과 시킨다.
                if (day == 0 && hour == 0 && min == 0) {
                    return { result: true };
                }

                let limitDate = moment().subtract(parseInt(day), 'days');
                if (!Utils.isEmpty(time)) {
                    limitDate.subtract(parseInt(hour), 'hours').subtract(parseInt(min), 'minutes');
                }

                // 예약 가능일 이후 부터 현재까지의 범위 안에 예약일시가 있어야 예약 가능
                let result = {
                    result: moment(reservDate).isAfter(limitDate),
                    date: limitDate.format(dFormat),
                };
                return result;
            }
        },
        async checkLessonCountNew(lessonDate) {
            if (this.isModify) {
                return true;
            }

            for (const ticket of this.selectedTicketValueList) {
                let centerCustomerId = 0;
                let centerContractId = 0;
                let centerProductId = 0;

                if (this.isFixedContract) {
                    centerCustomerId = this.$parent.centerCustomerId;
                    centerContractId = this.$parent.centerContractId;
                    centerProductId = this.$parent.centerProductId;
                } else {
                    centerCustomerId = ticket.centerCustomerId;
                    centerContractId = ticket.centerContractId;
                    centerProductId = ticket.centerProductId;
                }

                // 스웨거 검색: 수업횟수 확인
                const { data } = await api.get(
                    `/admin/api/center/${this.centerId}/lesson/schedule/check/less/count/over`,
                    {
                        params: {
                            centerCustomerId,
                            centerContractId,
                            centerProductId,
                            lessonDate: moment(lessonDate).format('YYYYMMDD'),
                        },
                    }
                );

                // this.isCheckOver = data.result;
                if (data.result) {
                    this.lessonTimeAlertMsg = '예약가능한 수업횟수를 모두 사용하였습니다.';
                }
            }
        },
        async timeFetchNew() {
            const { selectFormStartHour, selectFormStartMin } = this;
            // initialize
            // (selectFormStartHour.data = []), (selectFormStartHour.value = []);
            (selectFormStartMin.data = []), (selectFormStartMin.value = []);

            for (const ticket of this.selectedTicketValueList) {
                // 20220404 주석처리.. 부모 컴포넌트에서 전달받은 데이터까지 초기화 함..;
                let data = '';
                try {
                    // 20220404 부모컴포넌트에서 받은 스케줄시간을 가지고 중복예약이 있는지 체크한다.
                    data = await this.getLessonScheduleDuplicateCustomerNew(ticket);

                    if (data.data) {
                        this.lessonTimeAlertMsg = '해당 시간은 이미 예약된 내역이 있어 중복예약됩니다.';
                    } else {
                    }
                } catch {
                    // 스케줄 매뉴를 통해 들어오지 않으면 부모에서 주는 데이터가 없어 에러가 난다..
                    // 초기화한다.
                    (selectFormStartHour.selectedValue = ''), (selectFormStartMin.selectedValue = '');
                }
            }
            // 회원이 같은시간에 예약이 있을경우...

            // 수업시작 시간 : 시
            // for (let h = 0; h < 24; h++) {
            //     let hour = h.toString().padStart(2, '0');
            //     selectFormStartHour.data.push(hour);
            //     selectFormStartHour.value.push(hour);
            // }
            // 수업시작 시간 : 분
            const timeUnitValue = this.reservationSetting.timeUnitValue;
            if (timeUnitValue < 60) {
                for (let m = 0; m < 60; m += timeUnitValue) {
                    let min = m.toString().padStart(2, '0');
                    selectFormStartMin.data.push(min);
                    selectFormStartMin.value.push(min);
                }
            } else {
                selectFormStartMin.data.push('00');
                selectFormStartMin.value.push('00');
            }
        },
        getLessonScheduleDuplicateCustomerNew(ticket) {
            const {
                lessonDate,
                selectFormLessonTime,
                selectFormStartHour,
                selectFormStartMin,
                selectedCustomer,
                centerLessonScheduleId,
            } = this;

            const centerCustomerId = ticket.centerCustomerId;
            const tmFormat = 'HH:mm:ss';
            const dtFormat = 'YYYY-MM-DD HH:mm:ss';

            if (selectFormStartHour.selectedValue == '') {
                return;
            } else if (selectFormStartMin.selectedValue == '') {
                return;
            }
            const startTime = `${selectFormStartHour.selectedValue}:${selectFormStartMin.selectedValue}:00`;

            let lessonStartDatetime = `${lessonDate} ${startTime}`;

            const endTime = moment(lessonStartDatetime, dtFormat)
                .add(selectFormLessonTime.selectedValue, 'minutes')
                .format(tmFormat);

            const params = {
                centerCustomerId,
                centerLessonScheduleId,
                lessonDate,
                startTime,
                endTime,
            };

            // @스웨거 검색: 스케줄 시간 중복 체크
            return api.get(`/admin/api/center/${this.centerId}/lesson/schedule/duplicate/customer`, { params });
        },
        // 연락처 split
        splitPhoneNumber(phoneNumber) {
            // console.log(phoneNumber);

            if (!phoneNumber) return phoneNumber;

            phoneNumber = phoneNumber.replace(/[^0-9]/g, '');

            const tmp = ['', '', ''];
            if (phoneNumber.length < 4) {
                return phoneNumber;
            } else if (phoneNumber.length < 7) {
                tmp[0] = phoneNumber.substr(0, 3);
                tmp[1] = phoneNumber.substr(3);
            } else if (phoneNumber.length == 8) {
                tmp[0] = phoneNumber.substr(0, 4);
                tmp[1] = phoneNumber.substr(4);
            } else if (phoneNumber.length < 10) {
                if (phoneNumber.substr(0, 2) == '02') {
                    // 02-123-5678
                    tmp[0] = phoneNumber.substr(0, 2);
                    tmp[1] = phoneNumber.substr(2, 3);
                    tmp[2] = phoneNumber.substr(5);
                }
            } else if (phoneNumber.length < 11) {
                if (phoneNumber.substr(0, 2) == '02') {
                    // 02-1234-5678
                    tmp[0] = phoneNumber.substr(0, 2);
                    tmp[1] = phoneNumber.substr(2, 4);
                    tmp[2] = phoneNumber.substr(6);
                } else {
                    // 010-123-4567
                    tmp[0] = phoneNumber.substr(0, 3);
                    tmp[1] = phoneNumber.substr(3, 3);
                    tmp[2] = phoneNumber.substr(6);
                }
            } else {
                // 010-1234-5678
                tmp[0] = phoneNumber.substr(0, 3);
                tmp[1] = phoneNumber.substr(3, 4);
                tmp[2] = phoneNumber.substr(7);
            }
            return tmp;
        },
        // 이용권 시간 파싱
        convertTicketLessonTime(lessonTime) {
            const hour = Math.floor(Number(lessonTime) / 60);
            let minute = Number(lessonTime) % 60;

            minute = minute < 10 ? `0${minute}` : `${minute}`;

            if (hour === 0 && minute === 0) {
                return;
            } else if (minute === '00') {
                return `${hour}시간`;
            } else if (hour === 0) {
                return `${minute}분`;
            }

            return `${hour}시간 ${minute}분`;
        },
        // 이용권 리스트 파싱
        async fetchCustomerProductTicketList() {
            // 초기화
            this.centerContractBillTicketValueList = [];
            this.centerContractBillTicketNameList = [];

            try {
                // 내 이용권 추가
                if (this.selectedCustomer.id) {
                    const { data: contractData } = await this.getCustomerProductTicket(this.selectedCustomer.id);
                    contractData.forEach((g) => {
                        let lessonCount = '';
                        let ticketTypeName = Utils.getTicketTypeName(g.centerProduct.ticketType);

                        // 출석 현황
                        if (g.lessonCountType === 'T') {
                            lessonCount = `총 ${g.lessonResvCount}/${g.lessonCount}`;
                        } else if (g.lessonCountType === 'W') {
                            lessonCount = `주 ${g.lessonResvCount}/${g.lessonCount}`;
                        } else if (g.lessonCountType === 'U') {
                            lessonCount = `무제한`;
                        }

                        // 셀렉트 박스 name
                        const name = `${g.centerCustomer.name} | ${maskCustomerPhone(
                            this.splitPhoneNumber(g.centerCustomer.phone).join('-')
                        )}
                  [${ticketTypeName}] ${g.productName} | ${this.convertTicketLessonTime(
                            g.centerProduct.lessonTime
                        )} | ${lessonCount} | ${g.expireStartDt} ~ ${g.expireEndDt}`;
                        // console.log("name : ", name);

                        if (
                            this.selectedProduct != null &&
                            this.selectedTicketValueList.length == 0 &&
                            this.selectedProduct.centerContractId == g.centerContractId
                        ) {
                            this.selectedTicketList.push(name);
                            this.selectedTicketValueList.push(g);
                        }
                    });
                }

                // 이용권 리스트 조회
                const { data } = await this.getCustomerProductTicketList();
                // console.log("customerProductTicketList : ", data);
                // console.log("this.reserveType : ", this.reserveType);

                // 개인, 듀엣 필터링
                let ticketList = data.filter((ticket) => {
                    if (this.reserveType === 'P') {
                        return ticket.centerProduct.ticketType === 'P' || ticket.centerProduct.ticketType === 'O';
                    } else if (this.reserveType === 'D') {
                        return ticket.centerProduct.ticketType === 'D';
                    }
                });

                // lessonTime 필터링
                if (this.selectedProduct != null) {
                    ticketList = ticketList.filter((ticket) => {
                        return ticket.centerProduct.lessonTime === this.selectedProduct.centerProduct.lessonTime;
                    });
                }
                if (this.selectedTicketValueList.length > 0) {
                    ticketList = ticketList.filter((ticket) => {
                        return (
                            ticket.centerProduct.lessonTime === this.selectedTicketValueList[0].centerProduct.lessonTime
                        );
                    });
                }

                ticketList.forEach(async (g) => {
                    if (!g.centerCustomer || !g.centerProduct) {
                        return;
                    }

                    let lessonCount = '';
                    let ticketTypeName = Utils.getTicketTypeName(g.centerProduct.ticketType);

                    // 출석 현황
                    if (g.lessonCountType === 'T') {
                        lessonCount = `총 ${g.lessonResvCount}/${g.lessonCount}`;
                    } else if (g.lessonCountType === 'W') {
                        lessonCount = `주 ${g.lessonResvCount}/${g.lessonCount}`;
                    } else if (g.lessonCountType === 'U') {
                        lessonCount = `무제한`;
                    }

                    // 셀렉트 박스 name
                    const name = `${g.centerCustomer.name} | ${maskCustomerPhone(this.splitPhoneNumber(g.centerCustomer.phone).join('-'))}
                [${ticketTypeName}] ${g.productName} | ${this.convertTicketLessonTime(
                        g.centerProduct.lessonTime
                    )} | ${lessonCount} | ${g.expireStartDt} ~ ${g.expireEndDt}`;
                    // console.log("name : ", name);

                    // 유효 이용권 필터링
                    if (
                        this.centerContractId != g.centerContractId &&
                        moment(g.expireEndDt).isSameOrAfter(moment(), 'day')
                        // && moment(g.expireStartDt).isSameOrBefore(moment(),'day')
                        // && this.currentProduct.centerProduct.lessonTime == g.centerProduct.lessonTime
                    ) {
                        // 모든 이용권의 예약 권한 적용(SC_EVENT_007)
                        if (
                            this.allowedMenuEvent.eventCds != null &&
                            !this.allowedMenuEvent.eventCds.includes('SC_EVENT_007')
                        ) {
                            if (this.staffId == g.lessonStaffId) {
                                this.centerContractBillTicketNameList.push(name);
                                this.centerContractBillTicketValueList.push(g);
                            }
                        } else {
                            this.centerContractBillTicketNameList.push(name);
                            this.centerContractBillTicketValueList.push(g);
                        }
                    }

                    // 내 이용권 추가
                    /*
                if(this.selectedProduct != null && this.selectedTicketValueList.length == 0 && this.selectedProduct.centerContractId == g.centerContractId) {
                    this.selectedTicketList.push(name);
                    this.selectedTicketValueList.push(g);
                }
                */
                });

                /*
            console.log("centerContractBillTicketValueList : ", this.centerContractBillTicketValueList);
            console.log("centerContractBillTicketNameList : ", this.centerContractBillTicketNameList);
            console.log("selectedTicketList : ", this.selectedTicketList);
            console.log("selectedTicketValueList : ", this.selectedTicketValueList);
            */
            } catch (error) {
                console.log(error);
            }
        },
        // 이용권 선택
        async onUpdateTicketWith(ticket) {
            // console.log('onUpdateTicketWith: ', ticket);
            if (ticket === '') return false;

            /*
        this.selectedCustomer = {
          id: val.centerCustomer.centerCustomerId,
          name: val.centerCustomer.name,
        };
        */
            // this.selectedProduct = product;

            // 이미 선택된 회원권 중복 체크
            const isSelected = this.selectedTicketValueList.some((item) => {
                if (item.centerContractId == ticket.centerContractId) {
                    return true;
                }
            });
            if (isSelected) {
                alert('이미 선택된 이용권입니다.');
                return;
            }

            // 동일 lessonTime 체크
            const isInvalidLessonTime = this.selectedTicketValueList.some((item) => {
                if (item.centerProduct.lessonTime != ticket.centerProduct.lessonTime) {
                    return true;
                }
            });
            if (isInvalidLessonTime) {
                alert('동일 시간 이용권이 아닙니다.');
                return;
            }

            // 회원권 추가
            const index = this.centerContractBillTicketValueList.findIndex(
                (billTicket) => billTicket.centerContractId == ticket.centerContractId
            );
            this.selectedTicketList.push(this.centerContractBillTicketNameList[index]);
            this.selectedTicketValueList.push(ticket);

            // 이용권 조회
            await this.fetchCustomerProductTicketList();

            // TICKET STEP 변경
            this.step = this.EDIT_STEP.TICKET;

            await this.checkSchedule();

            this.checkExteriorPlanNew();

            if (Utils.isEmpty(ticket)) {
                this.step = this.EDIT_STEP.TICKET;
            } else {
                this.selectFormLessonTime.selectedValue = ticket.centerProduct.lessonTime
                    ? ticket.centerProduct.lessonTime
                    : 60;
                await this.generateEditFieldRoomInfo();
                this.goNextEditStep();
            }

            // 수업일자가 셋팅되어있다면, 날짜 체크
            if (!Utils.isEmpty(this.lessonDate)) {
                this.checkLessonDateNew(this.lessonDate);

                // 20220404
                // 스케줄 -> 일일스케줄 -> 스케줄 예약시 이용권을 선택시 수업시간을 표현하기 위해 추가.
                this.timeFetchNew();

                this.checkLessonCountNew(this.lessonDate);
            }
        },
        // 선택한 이용권 삭제
        async deleteTicket(index) {
            // console.log('deleteTicket: ', index);
            if (index === '') return false;

            this.selectedTicketList.splice(index, 1);
            this.selectedTicketValueList.splice(index, 1);

            // 이용권 조회
            await this.fetchCustomerProductTicketList();
        },
        // 이용권 변경
        async onUpdateReserveType(val) {
            // console.log('onUpdateReserveType: ', val);
            if (val === '') return false;
            // console.log('this.reserveType: ', this.reserveType);

            // 데이터 리셋
            // await this.resetData();
            this.centerContractBillTicketNameList = [];
            this.centerContractBillTicketValueList = [];
            this.selectedTicketList = [];
            this.selectedTicketValueList = [];

            // 이용권 조회
            await this.fetchCustomerProductTicketList();

            // 회원 선택 리랜더링
            this.selectFormSearchKey += 1;
        },
        // 이용권(비 그룹레슨) 목록조회
        getCustomerProductTicketList() {
            // 스웨거 검색: 이용권(비 그룹레슨) 목록조회
            return api.get(`/admin/api/center/${this.centerId}/customer/ticket/notGroup`);
        },
    },
};
</script>

<style scoped></style>
